import { FontIcon } from '@fluentui/react';
import { Tooltip } from 'antd'
import React from 'react'
interface InfoButtonProps {
  disabled?: boolean; 
  onClick?: () => void;
}

function InfoButton({ disabled ,onClick }: InfoButtonProps) {
  return (
    <Tooltip placement="bottom" title="Edit Job">
  <button  disabled={disabled}
    className="button action" onClick={onClick}>
     <FontIcon iconName="Info"/>
  </button>
</Tooltip>
  )
}

export default InfoButton
